import React, { useState } from "react";
import {
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import DeleteIcon from "@mui/icons-material/Delete";

import Button from "../../../common/Button";

const UserList = ({
  csvData,
  handleSaveRow,
  editingRow,
  setEditingRow,
  handleEditRow,
  handleBackStep,
  handleSubmit,
  selectedTypeTitle,
  selectedGroupName,
  handleDeleteRow,
}) => {
  const [editValues, setEditValues] = useState({});

  // Initialize edit values when a row is selected for editing
  const startEditing = (index) => {
    setEditValues({
      fullName: csvData[index].fullName,
      email: csvData[index].email,
      location: csvData[index].location || "",
    });
    handleEditRow(index);
  };

  // Handle input changes without saving immediately
  const handleInputChange = (field, value) => {
    setEditValues({
      ...editValues,
      [field]: value,
    });
  };

  // Save changes when user clicks the check icon
  const saveChanges = (index) => {
    // Save each field
    for (const field in editValues) {
      handleSaveRow(index, field, editValues[field]);
    }
    // Clear edit values and exit edit mode
    setEditValues({});
    setEditingRow(null);
  };

  // Cancel editing without saving
  const cancelEditing = () => {
    setEditValues({});
    setEditingRow(null);
  };

  return (
    <div>
      <Typography variant="h5" fontWeight={"bold"} mb={2}>
        Review New Users
      </Typography>
      <Typography variant="body2">
        Add to{" "}
        <Typography
          component="span"
          style={{ textDecorationLine: "underline", fontWeight: "bold" }}
        >
          {selectedTypeTitle}
          {"  "}
        </Typography>
        list in the group{" "}
        <Typography
          component="span"
          style={{ textDecorationLine: "underline", fontWeight: "bold" }}
        >
          {selectedGroupName}
        </Typography>
      </Typography>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Full Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Location</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {csvData.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                {editingRow === index ? (
                  <TextField
                    value={editValues.fullName}
                    onChange={(e) =>
                      handleInputChange("fullName", e.target.value)
                    }
                    fullWidth
                  />
                ) : (
                  row.fullName
                )}
              </TableCell>
              <TableCell>
                {editingRow === index ? (
                  <TextField
                    value={editValues.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    fullWidth
                  />
                ) : (
                  row.email
                )}
              </TableCell>
              <TableCell>
                {editingRow === index ? (
                  <TextField
                    value={editValues.location}
                    onChange={(e) =>
                      handleInputChange("location", e.target.value)
                    }
                    fullWidth
                  />
                ) : (
                  row.location || ""
                )}
              </TableCell>
              <TableCell>
                {editingRow === index ? (
                  <>
                    <IconButton
                      onClick={() => saveChanges(index)}
                      color="primary"
                    >
                      <CheckIcon />
                    </IconButton>
                    <IconButton onClick={cancelEditing}>
                      <DeleteIcon />
                    </IconButton>
                  </>
                ) : (
                  <>
                    <IconButton
                      onClick={() => startEditing(index)}
                      color="primary"
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => handleDeleteRow(index)}>
                      <DeleteIcon />
                    </IconButton>
                  </>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <div style={{ display: "flex", flexDirection: "column", marginTop: 8 }}>
        <Button onClick={handleSubmit} text="Submit" />
        <Button onClick={handleBackStep} text="Back" backgroundColor="white" />
      </div>
    </div>
  );
};

export default UserList;
